import React from "react";
import {Editor} from "components";

const styles = {
  container: {
    padding: '10px 0',
  },
  defaultCursor: {
    cursor: 'default'
  },
  title: {
    fontWeight: 'bold'
  },
  table: {
    width: '100%',
    border: '1px solid',
    borderCollapse: 'collapse',
    boxSizing: 'border-box'
  },
  thead: {
    backgroundColor: 'rgba(0, 0, 0, 0.1)'
  },
  th: {
    textAlign: 'left',
    padding: '2px 8px',
    fontSize: '13px'
  },
  descriptionTitle: {
    marginBottom: '8px'
  },
  center: {
    textAlign: 'center',
  },
  top: {
    verticalAlign: 'top'
  },
  tdTitle: {
    textAlign: 'center',
    height: '1px'
  },
  tdDescription: {
    height: '1px',
    paddingTop: '16px',
    paddingBottom: '16px'
  },
  td: {
    border: '1px solid',
    fontSize: '13px',
    padding: '8px'
  },
  tdImage: {
    width: '30%',
    textAlign: 'center',
    borderRight: 'none'
  },
  tdImgSelector: {
    borderLeft: 'none'
  }
};

const GageSeriesData = (props) => {
  const {product, content, setContent, removableArea: RemovableArea} = props;
  const setDescriptionContent = (value) => setContent?.({
    ...content, description: value
  });
  const stopPropagation = (e) => e.stopPropagation();

  return (
    <RemovableArea
      data-removable={true}
      id="gageSeriesData"
      style={styles.container}
    >
      <table border="1px solid" cellSpacing="0"
             style={styles.table}>
        <thead style={styles.thead}>
        <tr>
          <th colSpan="7" style={styles.th}>
            GAGE SERIES DATA
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td style={{...styles.td, ...styles.tdTitle}}>
            <span style={styles.title}>Series</span>
          </td>
          <td style={{...styles.td, ...styles.tdTitle}}>
            <span style={styles.title}>Description</span>
          </td>
          <td style={{...styles.td, ...styles.tdTitle}}>
            <span style={styles.title}>Strain Range</span>
          </td>
          <td style={{...styles.td, ...styles.tdTitle}}>
            <span style={styles.title}>Temperature Range</span>
          </td>
        </tr>
        <tr>
          <td style={{...styles.td, ...styles.center}}>
            {product.specifications?.stress_analysis_series?.[0]}
          </td>
          <td style={{...styles.td, ...styles.defaultCursor}}
              onMouseOver={stopPropagation}
              onMouseOut={stopPropagation}
              onClick={stopPropagation}>
            <Editor
              content={content?.description}
              setContent={setDescriptionContent}
            />
          </td>
          <td style={{...styles.td, ...styles.center}}>
            &plusmn;{product.characteristics?.strain_range}%
          </td>
          <td style={styles.td}>
            {product.characteristics?.temperature_range}
          </td>
        </tr>
        </tbody>
      </table>
    </RemovableArea>
  );
};

export default GageSeriesData;
